export const splitLinesForCSV = (text: string, length = 16) => {
  const pattern = `.{1,${length}}([a-zA-Z0-9_ñáéíóúüÑÁÉÍÓÚÜ\u0301]*)\\W*`;
  const regExp = new RegExp(pattern, 'g');
  return (text.match(regExp) || []).join('\n');
};
